import React from 'react';
import { useQueryParams } from '../utils/hooks';
import { VideoContextProvider } from './VideoPlayerContext';
import WebPlayerRecorder from './WebPlayerRecorder';

/**
 * Componente `FullscreenWebplayer`
 *
 * Questo componente visualizza il lettore WebPlayerNew in modalità fullscreen.
 * Utilizza i parametri della query string dell'URL per configurare le proprietà
 * del componente WebPlayerNew.
 *
 * I parametri accettati tramite la query string includono:
 * - `drill`: l'identificativo del drill attuale (facoltativo).
 * - `sessionId`: l'identificativo della sessione (facoltativo).
 * - `teamId`: l'identificativo del team (facoltativo).
 * - `templateId`: l'identificativo del template attuale (facoltativo).
 *
 * Il componente `useQueryParams` viene utilizzato per leggere e gestire i parametri
 * della query string dell'URL.
 *
 * @example: http://localhost:8080/fullscreen-session-recorder?sessionId=62003&teamId=397&templateId=1570
 *
 * @returns {JSX.Element} Il componente FullscreenWebplayer.
 */
const FullscreenWebplayerRecorder = (): JSX.Element => {
  const [queryParams] = useQueryParams();

  return <div className="fullscreen-webplayer">
    <VideoContextProvider>
      <WebPlayerRecorder
        currentDrill={queryParams.drill ? parseInt(queryParams.drill, 10) : null}
        sessionId={queryParams.sessionId}
        teamId={queryParams.teamId}
        templateId={queryParams.templateId}
        isFullscreen
      />
    </VideoContextProvider>
  </div>
;
};

export default FullscreenWebplayerRecorder;
